// Pagination loading indicator
document.addEventListener('DOMContentLoaded', () => {
  const paginationLinks = document.querySelectorAll('.pagination a');
  
  paginationLinks.forEach(link => {
    link.addEventListener('click', () => {
      // Find the closest table container
      const tableContainer = link.closest('.bg-white.rounded-lg.shadow');
      
      if (tableContainer) {
        // Create loading overlay
        const loadingOverlay = document.createElement('div');
        loadingOverlay.dataset.paginationOverlay = '';
        loadingOverlay.className = 'absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-10';
        loadingOverlay.innerHTML = `
          <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        `;
        
        // Make the table container relative for absolute positioning
        tableContainer.style.position = 'relative';
        tableContainer.appendChild(loadingOverlay);
      }
    });
  });
});

// back button can restore the page from bfcache with the spinner still up
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;
  document.querySelectorAll('[data-pagination-overlay]').forEach(el => el.remove());
});
